export const AddNotesHoverIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22 13.2C22 17.6997 22 19.9495 20.8541 21.5267C20.484 22.0361 20.0361 22.484 19.5267 22.8541C17.9495 24 15.6997 24 11.2 24C6.70032 24 4.45048 24 2.87329 22.8541C2.36392 22.484 1.91597 22.0361 1.5459 21.5267C0.399999 19.9495 0.399999 17.6997 0.399999 13.2V10.8C0.399999 9.79327 0.399999 8.89916 0.412833 8.1L0.496983 8.1C1.5194 8.10009 2.14219 8.10014 2.6794 8.01505C5.63186 7.54743 7.94742 5.23186 8.41505 2.2794C8.50013 1.74219 8.50009 1.1194 8.5 0.0969841L8.5 0.0128334C9.29916 0 10.1933 0 11.2 0C15.6997 0 17.9495 0 19.5267 1.1459C20.0361 1.51597 20.484 1.96392 20.8541 2.47329C22 4.05048 22 6.30032 22 10.8V13.2ZM10.3 9.6C10.3 9.10294 10.7029 8.7 11.2 8.7C11.6971 8.7 12.1 9.10294 12.1 9.6V12.3H14.8C15.2971 12.3 15.7 12.7029 15.7 13.2C15.7 13.6971 15.2971 14.1 14.8 14.1H12.1V16.8C12.1 17.2971 11.6971 17.7 11.2 17.7C10.7029 17.7 10.3 17.2971 10.3 16.8V14.1H7.6C7.10294 14.1 6.7 13.6971 6.7 13.2C6.7 12.7029 7.10294 12.3 7.6 12.3H10.3V9.6Z"
        fill="#245cea"
      />
      <path
        d="M2.39781 6.23721C2.02775 6.29582 1.57081 6.29984 0.478403 6.29999C0.591692 4.57245 0.868678 3.4054 1.5459 2.47329C1.91597 1.96392 2.36392 1.51597 2.87329 1.1459C3.8054 0.468679 4.97245 0.191693 6.69999 0.0784035C6.69984 1.17081 6.69582 1.62775 6.63721 1.99782C6.29157 4.18007 4.58007 5.89158 2.39781 6.23721Z"
        fill="#245cea"
      />
    </svg>
  );
};
